import DashboardHeader from "@/components/DashboardHeader";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { DELETE, GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import { API_ROUTES } from "@/services/environment";
import { Link, useSearchParams } from "react-router-dom";
import FormModal from "@/components/modals/FormModal";
import PreviewQuoteTemplate from "./models/previewQutoeTemplate/PreviewQuoteTemplate";
import QuoteTemplateList from "./models/quoteTemplateList/QuoteTemplateList";
import { Booking, Business } from "./Interface";
import { EventDetailPage } from "./EventDetailPage";
import CompletedEvents from "./components/CompletedEvents";
import { IoMdArrowBack } from "react-icons/io";
import { format, parseISO } from "date-fns";
import useLoading from "@/hooks/useLoading";
import {
    Button,
    Loader,
} from "@thdinc/hpf-shared";
import EventTabs from "./components/EventTabs";
import EventListPage from "../eventListPage/EventListPage";
import SearchInputComponent from "../eventListPage/SearchInputComponent";
import { QuoteEventDetailPage } from "./QuoteEventDetailPage";
import EventCards from "./components/EventCards";
interface User {
    first_name: string;
    last_name: string;
    roles: string;
    // Add other properties of the user object if available
}

const EventsPage = () => {
    // const params = useParams();
    const location = useLocation();
    localStorage.removeItem("eventId");
    const { isLoading, startLoading, stopLoading } = useLoading();

    useEffect(() => {
        if (location.state?.url) {
            if (location.state.url.split("/")[2]) {
                setBookingId(location.state.url.split("/")[2]);
            } else {
                setBookingId(location.state.url);
            }
            setDetailView(true);
        }
    }, [location.state]);

    const { getUpcomingEventApi } = API_ROUTES;
    const [currentQueryParameters, setSearchParams] = useSearchParams();
    const newQueryParameters: URLSearchParams = new URLSearchParams();
    const { refreshToken } = useAppSelector((store) => store.user);

    const navigate = useNavigate();
    const [currTab, setCurTab] = useState("Bookings");
    const [currBusiness, setCurBusiness] = useState<any>(null);
    const [upComingEvent, setUpComingEvent] = useState<Booking[]>([]);
    const [rerender, setRerender] = useState<boolean>(false);
    const [detailView, setDetailView] = useState(false);
    const [bookingType, setBookingType] = useState({
        isQuoteBooking: false,
        isUpcomingEvent: false,
    });
    const [bookingId, setBookingId] = useState<string>("");
    const [isCardModalOpen, setIsCardModalOpen] = useState(false);
    const [quoteTemplateList, setQuoteTemplateList] = useState<any[]>([]);
    const [viewDetailModalOpen, setViewDetailModalOpen] = useState(false);
    const [selectedQuote, setSelectedQuote] = useState<any>(null);
    const [deletingQuoteId, setDeletingQuoteId] = useState<string | null>(null);
    const idParam = currentQueryParameters.get("id");
    useEffect(() => {
        if (idParam) {
            return;
        }
        if (currTab === "Bookings") {
            const getUpcoming = async () => {
                try {
                    startLoading();
                    const result = await GET(`${getUpcomingEventApi}`, refreshToken);
                    setUpComingEvent(result?.data);
                } catch (err) {
                    console.log(String(err));
                } finally {
                    stopLoading();
                }
            };
            getUpcoming();
        }
    }, [currTab, rerender, idParam]);

    // update tab also close open forms state (Package and cocktails)
    const updateTab = (name: string) => {

        setCurTab(name);
        setBookingId("");
        setDetailView(false);
        newQueryParameters.set("tab", "dw");
        navigate(`?tab=${name}`);
    };

    const updateBusiness = (business: any) => {
        setCurBusiness(business)
    }

    const getQuotesTemplates = async () => {
        try {
            const res = await GET(
                `${API_ROUTES.listAllQuotesWithFilteration}?is_template=${true}&business_id=${currBusiness?.id}`,
                refreshToken,
            );
            if (res.data) {
                setQuoteTemplateList(res.data.rows);
            }
        } catch (error) {
            console.log('get error in quote templates---:', error);
        }
    };

    const deleteQuoteById = async (quoteId: string) => {
        try {
            setDeletingQuoteId(quoteId);
            const res = await DELETE(
                `${API_ROUTES.deleteQuoteById}${quoteId ? `/${quoteId}` : ``}`,
                refreshToken,
            );
            if (res.data?.success) {
                getQuotesTemplates();
            }
        } catch (error) {
            console.log('delete quote error---:', error);
        } finally {
            setDeletingQuoteId(null);
        }
    };

    const closeCardModal = () => {
        setIsCardModalOpen(false);
        setViewDetailModalOpen(false);
    };

    useEffect(() => {
        if (currBusiness?.id) {
            getQuotesTemplates();
        }
    }, [currBusiness]);

    // Sync tab (and optional id) from URL so sidebar navigation updates EventTabs
    const validTabs = ["Leads", "Bookings", "Completed Events"];
    useEffect(() => {
        const tab = currentQueryParameters.get("tab");
        if (tab && validTabs.includes(tab)) {
            setCurTab(tab);
        } else if (!tab) {
            setCurTab("Bookings");
        }
        const id = currentQueryParameters.get("id");
        if (id) {
            setBookingId(id);
            setDetailView(true);
            setBookingType({
                isQuoteBooking: currentQueryParameters.get("is_quote_booking") === "true",
                isUpcomingEvent: currentQueryParameters.get("is_upcoming_event") === "true",
            });
        } else {
            setBookingId("");
            setDetailView(false);
        }
    }, [location.search]);
    const openDetailView = (bookingId: string, is_quote_booking?: boolean, isUpcomingEvent?: boolean) => {
        setDetailView(true);
        setBookingId(bookingId);
        setBookingType({
            isQuoteBooking: is_quote_booking ?? false,
            isUpcomingEvent: isUpcomingEvent ?? false
        });
        const params = new URLSearchParams(location.search);
        params.set("id", bookingId);
        params.set("is_quote_booking", String(is_quote_booking ?? false));
        params.set("is_upcoming_event", String(isUpcomingEvent ?? false));
        navigate(`?${params.toString()}`);
    };

    const [searchQuery, setSearchQuery] = useState("");

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };

    const fitleredUpcoming = upComingEvent.filter((item: Booking) => {
        const { start_time } = item;
        const date = format(parseISO(start_time), "PPPP");
        const adminName = `${item.first_name} ${item.last_name}`.toLowerCase();
        const search = searchQuery.toLowerCase();
        return (
            date.toLocaleLowerCase().includes(search) || adminName.includes(search)
        );
    });

    return (
        <div>
            <div className="flex items-start md:items-center gap-1 flex-wrap justify-between mt-2 sticky top-[64px] bg-p-gray z-30">
                <div className="flex gap-3 items-center cursor-pointer w-full">
                    {detailView && (
                        <div
                            onClick={() => {
                                setDetailView(false);
                                setSearchQuery("");
                                const params = new URLSearchParams(location.search);
                                params.delete("id");
                                params.delete("is_quote_booking");
                                params.delete("is_upcoming_event");
                                navigate(`?${params.toString()}`);
                            }}
                            className="bg-white p-2 mt-4 md:mt-2 rounded-full"
                        >
                            <IoMdArrowBack />
                        </div>
                    )}
                    <DashboardHeader width="w-full" title="Events">
                        <div>
                            <Button
                                className="
              md:hidden
               text-black
              rounded-full
              border border-black
              py-2 px-3
              font-medium
              flex items-center justify-center
              text-xs sm:text-sm md:text-base
            "
                                onClick={() => {
                                    if (quoteTemplateList.length === 0) {
                                        navigate('/quoteBuilder', { state: { currBusiness } });
                                    } else {
                                        setIsCardModalOpen(true);
                                    }
                                }}
                            >
                                + New Quote
                            </Button>
                            <div className="w-full md:w-auto mt-4 md:mt-0 min-w-0">
                                <EventTabs currTab={currTab} updateTab={updateTab} updateBusiness={updateBusiness} />
                            </div>
                        </div>
                    </DashboardHeader>

                    {/* {bookingId === "" ? (
            <div
              className="flex  items-center"
              onClick={() => updateTab(currTab)}
            >
              <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
              <p className="underline hover:cursor-pointer text-primary-red ">
                {currTab}
              </p>
            </div>
          ) : (
            <div className="flex  items-center">
              <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
              <p
                onClick={() => updateTab(currTab)}
                className="underline hover:cursor-pointer text-primary-red "
              >
                {currTab}
              </p>
              <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
              <p className="underline hover:cursor-pointer text-primary-red translate-x-0">
                {bookingId}
              </p>
            </div>
          )} */}
                </div>
            </div>

            {currTab === "Completed Events" && !detailView && (
                <CompletedEvents openDetailView={openDetailView} />
            )}
            {currTab == "Leads" && !detailView && <EventListPage currBusiness={currBusiness} />}
            {currTab === "Bookings" &&
                !detailView &&
                (!isLoading ? (
                    <>
                        <div className="mt-1">
                            <SearchInputComponent
                                className="flex justify-end items-end"
                                handleSearch={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>

                        {fitleredUpcoming.length > 0 ? (
                            <div className="flex flex-col gap-3 mt-2">
                                <div className="grid grid-col-1 md:grid-cols-2 lg:grid-cols-3 transition-all gap-4 md:gap-6 lg:gap-8">
                                    {fitleredUpcoming.map((data, i) => (
                                        <div
                                            key={i}
                                            className="cursor-pointer"
                                            onClick={() => openDetailView(data?.id, data?.is_quote_booking, true)}
                                        >
                                            <EventCards data={data} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <p className="text-center text-gray-500 text-lg">No Booking</p>
                        )}
                    </>
                ) : (
                    <Loader color="bg-red-500" />
                ))}

            {/* Shoe Event Detail Page */}
            {detailView &&
                (bookingType?.isQuoteBooking ? (
                    <QuoteEventDetailPage
                        bookingId={bookingId}
                        rerender={rerender}
                        setRerender={setRerender}
                    />
                ) : (
                    <EventDetailPage
                        bookingId={bookingId}
                        rerender={rerender}
                        setRerender={setRerender}
                    />
                ))}

            {/* Mobile: Choose Template Modal */}
            <FormModal
                isEditButton={viewDetailModalOpen}
                overflow='overflow-hidden'
                modalTitle={viewDetailModalOpen ? 'Quote Preview' : 'Choose Template'}
                isOpen={isCardModalOpen}
                onClose={closeCardModal}
                width='lg:w-3/6 md:w-5/6 w-full'
                onEditClick={() => {
                    if (!selectedQuote) return;
                    setViewDetailModalOpen(false);
                    setIsCardModalOpen(false);
                    navigate(`/quoteBuilder/${selectedQuote.id}`, {
                        state: { currBusiness },
                    });
                }}
            >
                {viewDetailModalOpen ? (
                    <PreviewQuoteTemplate
                        viewDetailModalOpen={viewDetailModalOpen}
                        setViewDetailModalOpen={setViewDetailModalOpen}
                        quote={selectedQuote}
                    />
                ) : (
                    <QuoteTemplateList
                        quoteTemplateList={quoteTemplateList}
                        deletingQuoteId={deletingQuoteId}
                        onSelectTemplate={(data) =>
                            navigate(`/quoteBuilder/${data.id}`, {
                                state: { currBusiness },
                            })
                        }
                        onPreviewTemplate={(data) => {
                            setSelectedQuote(data);
                            setViewDetailModalOpen(true);
                        }}
                        onDeleteTemplate={deleteQuoteById}
                        onBlankProposal={() => {
                            closeCardModal();
                            navigate('/quoteBuilder', { state: { currBusiness } });
                        }}
                    />
                )}
            </FormModal>
        </div>
    );
};

export default EventsPage;
